<template>
	<div>
		<b-form-input v-model="term" v-focus.lazy="true" @keyup.native="load(term)" class="mb-2" placeholder="Search... (e.g. #jazz)" autocomplete="off"></b-form-input>
		<b-list-group>
			<b-list-group-item :to="'/songs/' + song.id + '/lyrics/' + song.language" class="flex-column align-items-start" v-for="song in songs">
				<h5 class="">{{song.title}}</h5>
				<small v-if="song.tags.length > 0">{{song.tags.map(tag => '#'+tag).join(", ")}}</small>
			</b-list-group-item>
		</b-list-group>
	</div>
</template>

<script>
	import axios from '../ConfiguredAxios.js'
	import {focus} from 'vue-focus'

	import { EventBus } from '../event-bus.js'

	export default {
		directives: { focus: focus },
		name: 'List',
		data: () => {
			return {
				term: "",
				songs: []
			}
		},
		created: function () {
			this.load(this.term)
			EventBus.$on(['SongAdded', 'SongRemoved', 'SongEdited'], () => {
				this.load(this.term)
			});
		},
		methods: {
			load: function (term) {
				axios.get("/rest/v1/songs", {
					params: {
						term: term
					}
				}).then(response => {
					// I'm sorry, but JS doesn't know much of flatMap
					this.songs = [];

					response.data.forEach(song => {
						Object.keys(song.titles).forEach(language => {
							this.songs.push({
								"id": song.id,
								"title": song.titles[language],
								"tags": song.tags,
								"language": language
							})
						})
					})
				})
			}
		}
	}
</script>
